(function () {
  // Get all elements with the class name you want to hover over
  const hoverElements = document.querySelectorAll(".has-sub");

  // Get the element you want to add a class to
  const targetElement = document.querySelector(".nav-backdrop");

  // Add event listeners to all hover elements
  hoverElements.forEach((hoverElement) => {
    hoverElement.addEventListener("mouseover", () => {
      // Add the class to the target element
      targetElement.classList.add("reveal");
    });

    hoverElement.addEventListener("mouseout", () => {
      // Remove the class from the target element
      targetElement.classList.remove("reveal");
    });
  });

  // accordion

  // Get all elements with class "panelheader"
  const panelHeaders = document.querySelectorAll(".panelheader");

  // Add a click event listener to each "panelheader"
  panelHeaders.forEach((panelHeader) => {
    panelHeader.addEventListener("click", function (event) {
      event.preventDefault();

      // Get a reference to the clicked panelheader
      const clickedPanelHeader = this;

      // Remove "panelopen" class from all panelheaders
      panelHeaders.forEach((panelHeader) => {
        panelHeader.classList.remove("panelopen");
      });

      // Determine whether to show or hide the clicked panel's contents
      const nextElement = clickedPanelHeader.nextElementSibling;
      if (nextElement.classList.contains("show")) {
        nextElement.classList.remove("show");
        nextElement.style.display = "none";
      } else {
        const parent = clickedPanelHeader.parentElement.parentElement;
        const innerElements = parent.querySelectorAll("li .inner");
        innerElements.forEach((innerElement) => {
          innerElement.classList.remove("show");
          innerElement.style.display = "none";
        });

        nextElement.classList.add("show");
        clickedPanelHeader.classList.add("panelopen");
        nextElement.style.display = "block";
      } 
    });
  });


// mobile nav

const headerPanels = document.querySelectorAll('.panel-header');

      headerPanels.forEach(panel => {
        const linkList = panel.nextElementSibling;
        const panelIndicator = panel.querySelector('.panel-indicator');
        let isPanelOpen = false;
        
        panel.addEventListener('click', () => {
          if (isPanelOpen) {
            linkList.style.display = 'none';
            panelIndicator.classList.remove('flip');
            isPanelOpen = false;
          } else {
            linkList.style.display = 'block';
            panelIndicator.classList.add('flip');
            isPanelOpen = true;
          }
        });
      });

  const mobileMenu = document.querySelector('#mobilemenu');
      const mobileNav = document.querySelector('#mobilenavigation');
      const closeBtn = document.querySelector('.close');

  mobileMenu.addEventListener('click', () => {
    mobileNav.classList.add('open');
  });

  closeBtn.addEventListener('click', () => {
  mobileNav.classList.remove('open');
});
  
// mobile nav

// brand scroll //

// Select all links with hashes
const links = document.querySelectorAll('.alphabet-grid a[href*="#"]');
links.forEach((link) => {
  link.addEventListener("click", function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      let target = document.querySelector(this.hash);
      if (target) {
        event.preventDefault();
        const currentSection = window.location.hash;
        if (currentSection !== this.hash) {
          handleSwitchSection(this.hash, target);
          history.pushState(null, null, this.hash);
        } else {
          target.parentElement.focus();
        }
      }
    }
  });
});

const handleSwitchSection = (hash, target) => {
  const element = document.querySelector(hash);
  element.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
  target.parentElement.setAttribute("tabindex", "-1");
  setTimeout(() => {
    target.parentElement.focus();
  }, 200);

  const space = target.offsetTop - window.pageYOffset;
  const offset = document.querySelector(".header-wrap").offsetHeight;
  console.log({ space, target }); 
  console.log(target);
  document.querySelector(".brand-wrapper-first").style.paddingBottom = `${space}px`;
  const topSpace = target.offsetTop - 140;
  window.scrollTo({
    top: topSpace,
    behavior: 'smooth'
  });
};
  
// brand scroll //
  
})();

function getSectionInnerHTML(html, selector = ".shopify-section") {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}

function updateFreeShipping() {
  fetch(window.location.pathname + `?sections=free-shipping`)
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const updateSection = getSectionInnerHTML(parsedState["free-shipping"]);
      document.getElementById("free-shipping-wrapper").innerHTML = updateSection;
    })
    .catch((e) => {
      console.log({ e });
    });
}

// country select auto submit
 document.querySelector('select[name="currency"]').addEventListener('change', function() {
  document.getElementById('ctry').submit();
});

/***
 * call this function when you want to render free shipping banner
 *  example: window.renderFreeShipping();
 */
window.renderFreeShipping = updateFreeShipping;

/* check the availability field by default */

document.addEventListener('DOMContentLoaded', function() {
  var checkbox1 = document.getElementById('Filter-filter.v.availability-1');
  if (checkbox1) {
    checkbox1.checked = true;
  }

  var checkbox2 = document.getElementById('Filter-filter.v.availability-mobile-1');
  if (checkbox2) {
    checkbox2.checked = true;
  }
});
